<template>
    <div>
        <v-dialog v-model="abrirDialog" max-width="650px" class="pa-5" persistent>
            <v-card>
                <v-btn icon class="close-btn" @click="fecharDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-card-title class="text-h5 font-weight-bold text-h5">Saldo devedor excedido</v-card-title>
                <br>
                <v-card-text>
                    <p class="text-body-1" style="font-size: 1.2rem; line-height: 1.6;">
                      Essa operação <strong>ultrapassa o limite de saldo devedor. Devido ao risco solicitado,</strong> essa proposta <strong>passará por uma analise de grandes negócios</strong> pela Área de Crédito.
                    </p>
                    <br>
                    <p class="text-body-1" style="font-size: 1.2rem; line-height: 1.6;">
                      Ao <strong>prosseguir</strong> na próxima etapa <strong>(Confirmação), automaticamente será aberto um protocolo</strong> na Área de Crédito para que a equipe possa <strong>analisar sua solicitação.</strong>
                    </p>
                    <br>
                    <div class="d-flex align-items-center my-4 info-block">
                        <div class="mr-4" style="width: 50%;">
                            <div style="font-size: 1.2rem; font-weight: bold;">Saldo devedor atual:</div>
                            <br>
                            <div class="value-dark" style="font-size: 1.4rem; font-weight: bold;">R$ {{ saldoDevedorCliente }}</div>
                        </div>
                        <v-icon mid class="mx-6 align-self-center">mdi-arrow-right</v-icon>
                        <div class="ml-4" style="width: 50%;">
                            <div style="font-size: 1.2rem; font-weight: bold;">Limite de crédito atual aprovado:</div>
                            <br>
                            <div style="font-size: 1.4rem; font-weight: bold;" class="primary--text">R$ {{ saldoAtual }}</div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center my-4 info-block">
                        <div class="mr-4" style="width: 50%;">
                            <div style="font-size: 1.2rem; font-weight: bold;">Limite de crédito disponível:</div>
                            <br>
                            <div class="value-dark" style="font-size: 1.4rem; font-weight: bold;">R$ {{ limiteDisponivel }}</div>
                        </div>
                        <v-icon mid class="mx-6 align-self-center">mdi-arrow-right</v-icon>
                        <div class="ml-4" style="width: 50%;">
                            <div style="font-size: 1.2rem; font-weight: bold;">Solicitação de limite de crédito:</div>
                            <br>
                            <div style="font-size: 1.4rem; font-weight: bold;" class="primary--text">+ R$ {{ novaSolicitacaoLimite }}</div>
                        </div>
                    </div>
                    <br>
                    <div class="d-flex justify-space-between my-4">
                        <div style="font-size: 1.2rem; font-weight: bold;">Valor por cota (sem taxas)</div>
                        <div class="value-dark" style="font-size: 1.4rem; font-weight: bold;">R$ {{ valorPorCota }}</div>
                    </div>
                    <div class="d-flex justify-space-between my-4">
                        <div style="font-size: 1.2rem; font-weight: bold;">Quantidade de cotas</div>
                        <div class="value-dark" style="font-size: 1.4rem; font-weight: bold;">{{ quantidadeCotas }}</div>
                    </div>
                    <hr>
                    <div class="d-flex justify-space-between my-4">
                        <div style="font-size: 1.2rem; font-weight: bold;">Valor total da proposta (com taxas)</div>
                        <div style="font-size: 1.4rem; font-weight: bold;" class="primary--text">R$ {{ valorTotalProposta }}</div>
                    </div>
                    <div class="d-flex justify-space-between my-4">
                        <div style="font-size: 1.1rem; font-weight: bold;">Saldo devedor futuro</div>
                        <div class="value-dark" style="font-size: 1.3rem; font-weight: bold;">R$ {{ saldoDevedorFuturo }}</div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn id="btn-prosseguir" color="primary" @click="prosseguir()">Prosseguir</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
  export default {
    props: {
      visivel: {
        type: Boolean,
        required: true
      },
      saldoAtual: {
        type: String,
        required: true
      },
      saldoParaAumentar: {
        type: String,
        required: true
      },
      saldoDevedorCliente: {
        type: String,
        required: true
      },
      saldoDevedorSolicitavel: {
        type: String,
        required: true
      },
      limiteDisponivel: {
        type: String,
        required: true
      },
      novaSolicitacaoLimite: {
        type: String,
        required: true
      },
      valorPorCota: {
        type: String,
        required: true
      },
      quantidadeCotas: {
        type: Number,
        required: true
      },
      valorTotalProposta: {
        type: String,
        required: true
      },
      saldoDevedorFuturo: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        abrirDialog: this.visivel
      }
    },
    watch: {
      visivel (newValue) {
        this.abrirDialog = newValue
      },
      abrirDialog (newValue) {
        if (newValue === false) {
          this.$emit('fecharInformativoSaldoDevedorCliente', newValue)
        }
      }
    },
    methods: {
      fecharDialog () {
        this.abrirDialog = false
        this.$emit('fecharInformativoLimiteCreditoPontoVendaExcedido', 'fechar')
      },
      prosseguir () {
        this.abrirDialog = false
        this.$emit('fecharProsseguirInformativoLimiteCreditoPontoVendaExcedido', 'prosseguir')
      }
    }
  }
</script>

<style scoped>
.v-dialog {
  padding: 32px;
}
.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
}
.v-icon.mx-6 {
  margin-left: 24px !important;
  margin-right: 24px !important;
}
.info-block {
  background-color: #F5F9F7;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.value-dark {
  color: #000000;
}
</style>
